import React from 'react';
import mapNodes from 'helpers/mapNodes';
import PropTypes from 'prop-types';
import CaseStudiesPage from 'components/CaseStudiesPage';

const propTypes = {
  data: PropTypes.shape({
    allContentfulCaseStudy: PropTypes.object,
  }).isRequired,
};

function CaseStudiesPageContainer({ data }) {
  return (
    <CaseStudiesPage caseStudies={mapNodes(data.allContentfulCaseStudy)} />
  );
}

CaseStudiesPageContainer.propTypes = propTypes;

export default CaseStudiesPageContainer;

export const query = graphql`
  query CaseStudiesPageQuery {
    allContentfulCaseStudy(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          id
          node_locale
          featured
          heading
          slug
          subHeading
          excerpt {
            excerpt
          }
          industry
          services {
            services
          }
          content {
            id
            content
          }
          headerBackgroundImage {
            title
            description
            responsiveResolution(width: 800) {
              width
              height
              src
              srcSet
            }
          }
          cardImage {
            title
            description
            responsiveResolution(width: 800) {
              width
              height
              src
              srcSet
            }
          }
          relatedCaseStudies {
            id
            heading
            slug
            subHeading
            cardImage {
              title
              description
              responsiveResolution(width: 800) {
                width
                height
                src
                srcSet
              }
            }
          }
          testimonial {
            id
            name
            position
            testimonial {
              text: testimonial
            }
            logo {
              fullSize: resolutions(width: 330) {
                src
              }
            }
          }
          seoDescription {
            seoDescription
          }
          seoKeywords
          seoTitle
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/work.js